export const SET_SIDEBAR_STATUS = 'sidebar/SET_SIDEBAR_STATUS'

export const SET_SOCIO_EXPANDED = 'sidebar/SET_SOCIO_EXPANDED'

export const SET_CONFIG_EXPANDED = 'sidebar/SET_CONFIG_EXPANDED'
